import { render, staticRenderFns } from "./RequestReviewForm.vue?vue&type=template&id=05de1e42&scoped=true"
import script from "./RequestReviewForm.vue?vue&type=script&lang=js"
export * from "./RequestReviewForm.vue?vue&type=script&lang=js"
import style0 from "./RequestReviewForm.vue?vue&type=style&index=0&id=05de1e42&prod&lang=stylus&scoped=true"
import style1 from "./RequestReviewForm.vue?vue&type=style&index=1&id=05de1e42&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de1e42",
  null
  
)

export default component.exports